import React from 'react';

interface FooterLink {
  href: string;
  label: string;
}

const footerLinks: FooterLink[] = [
  { href: '#features', label: 'Features' },
  { href: '#how', label: 'How it works' },
  { href: '#faq', label: 'FAQ' },
  { href: '/login', label: 'Become an artist?' },
];

/**
 * Landing footer. Only real destinations remain: in-page anchors plus the
 * login route. Placeholder `#` links (Changelog, About, Blog, Careers,
 * Privacy, Terms), the dead `#pricing` anchor, and the nonexistent `/signup`
 * path are removed.
 */
const LandingFooter: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-white/20 bg-black/20 py-8 text-[#2f2f2d]">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 px-5 md:flex-row md:items-start md:justify-between">
        <div>
          <div className="text-lg font-bold">InkVoyd</div>
          <p className="mt-2 max-w-sm text-sm text-[#2f2f2d]">
            Filling your books like you pack a sleeve. A service made especially
            for tattoo artists.
          </p>
        </div>
        <nav aria-label="Footer">
          <ul className="flex flex-col gap-2 text-sm text-[#2f2f2d]">
            {footerLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="hover:underline focus:outline-none focus:ring-2 focus:ring-[#2f2f2d]"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
      <div className="mx-auto mt-8 max-w-6xl px-5 text-xs text-[#2f2f2d]">
        © {year} InkVoyd. All rights reserved.
      </div>
    </footer>
  );
};

export default LandingFooter;
